import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/seasonalFeatured';

export const SEASONAL_FEATURED_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const SEASONAL_FEATURED_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;

export const SEASONAL_FEATURED_VIEW = `${rootActionPath}/VIEW`;
